// extracted by mini-css-extract-plugin
module.exports = {"root":"Heading_root__28zde","title":"Heading_title__1UVll","description":"Heading_description__AZHeg"};